import { TreeDiagramNode } from './node.class';

import { TreeDiagramNodeMaker } from "./node-maker.class"
import { nodeChildrenAsMap } from '../../../../../node_modules/@angular/router/src/utils/tree';
import {AppTreeDiagramComponent } from '../../app-tree-diagram/app-tree-diagram.component';
import {AppTreeDiagramService } from '../../app-tree-diagram/app-tree-diagram.service';

import { AuthenticationService } from "../../../views/authentication/authentication.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';


export class TreeDiagramNodesList {
  private http: HttpClient;
  private serv: AuthenticationService;
  appService = new AppTreeDiagramService(this.http, this.serv);
  
  appTreeComp = new AppTreeDiagramComponent(this.appService);



  public datos: any = [];
  private _nodesList = new Map();
  public roots: TreeDiagramNode[];
  public makerGuid: string;
  public draggingNodeGuid;
  private _nodeTemplate = {
    displayName: 'New node',
    children: [],
    guid: '',
    parentId: null
  }

  private uuidv4 () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  constructor (_nodes: any[], private config) {
    _nodes.forEach(_node => {
      this._nodesList.set(_node.guid, new TreeDiagramNode(this.appTreeComp,_node, config, this.getThisNodeList.bind(this)))
    });
    this._makeRoots()

    this.makerGuid = this.uuidv4()
    let node = {
      guid: this.makerGuid,
      parentId: 'root',
      children: [],
      displayName: 'New node'
    }
    let maker = new TreeDiagramNodeMaker(this.appTreeComp,node, this.config, this.getThisNodeList.bind(this))
    this._nodesList.set(this.makerGuid, maker)
  }

  private _makeRoots () {
    this.roots = Array.from(this.values()).filter((node: TreeDiagramNode) => node.isRoot())
  }

  public values () {
    return this._nodesList.values()
  }

  public getNode (guid: string): TreeDiagramNode {
    return this._nodesList.get(guid)
  }

  public rootNode(guid: string){
    let node = this.getNode(guid)
    node.isDragging = false
    node.isDragover = false
    if (node.parentId){
      let parent = this.getNode(node.parentId)
      parent.children.delete(guid)
    }
    node.parentId = null
    this._makeRoots()
    let maker = this.getNode(this.makerGuid)
    maker.isDragging = false
    maker.isDragover = false
  }

  public transfer (origin: string, target: string ) {
    let _origin = this.getNode(origin);
    let _target = this.getNode(target);
    _origin.isDragover = false;
    _origin.isDragging = false;
    _target.isDragover = false;
    if (_origin.parentId === target || origin === target) {
      return;
    }
    let remakeRoots = _origin.isRoot();
    if (_origin.parentId) {
      let _parent = this.getNode(_origin.parentId);
      _parent.children.delete(origin);
      if (!_parent.hasChildren()) {
        _parent.toggle(false)
      }
    }
    _target.children.add(origin);

    _origin.parentId = target;
    remakeRoots && this._makeRoots()

    this.serialize()
  }

  public getThisNodeList () {
    return this;
  }

//////////////////////////////////////////////////////////
  public toggleSiblings (guid: string) {
    
    let target = this.getNode(guid); //recibe y establece qué target será el nodo correspondiente al id.
    //Funcion colapsable
    if (target.hasChildren){
      target.children.forEach((nodeGuid) => {
        this.getNode(nodeGuid).toggle(false);
      })
    }
    //Función colapsable

    if (target.parentId) {//Si tiene un parent...
      
      let parent = this.getNode(target.parentId) //parent será igual al nodo correspondiente al padre del nodo inicial.
      parent.children.forEach((nodeGuid) => { // Para cada children...
        //BLOQUE ORIGINAL
        if (nodeGuid === guid) { //si el nodo actual es el mismo al inicial, se sale.
          return;
        }
        this.getNode(nodeGuid).toggle(false)// desactiva el nodo actual.
        //BLOQUE ORIGINAL
      })
    }

    else { //Si no tiene parent...
      for (let root of this.roots) { //Para cada raíz del nodo:
        if (root.guid === guid) { //Si el id de la raíz es el inicial...
          continue; //Continua.
        }
        root.toggle(false) //Desactiva la raíz de todos modos.
      }
    }
  }
//////////////////////////////////////////////////////////


  public serialize () {
    let out = []
    this._nodesList.forEach((node: TreeDiagramNode) => {
      this.datos = { //era let json: any = { y json ahora es datos
        guid: node.guid,
        displayName: node.displayName,
        parentId: node.parentId
      };
      this.datos.children = Array.from(node.children)

      out.push(this.datos)

    })
    return out
  }

  public destroy (guid: string) {
    let target = this.getNode(guid);
    if (target.parentId) {
      let parent = this.getNode(target.parentId)
      parent.children.delete(guid)
    }
    if (target.hasChildren()) {
      target.children.forEach((child: string) => {
        let theNode = this.getNode(child)
        theNode.parentId = null;
      })
    }
    this._nodesList.delete(guid)
    this._makeRoots()
    console.warn(this.values())
  }

  public newNode(parentId = null){
    let _nodeTemplate = Object.assign({}, this._nodeTemplate)
    _nodeTemplate.guid = this.uuidv4();
    _nodeTemplate.parentId = parentId;
    this._nodesList.set(_nodeTemplate.guid, new TreeDiagramNode(this.appTreeComp,_nodeTemplate, this.config, this.getThisNodeList.bind(this)))
    this._makeRoots()
    return _nodeTemplate.guid
  }


  

}


// WEBPACK FOOTER //
// ./src/app/components/angular2-tree-diagram/classes/nodesList.class.ts